module.exports = __webpack_public_path__ + "static/media/nile-sunset.682b42f9.webm";